import React, { useState, useEffect, useCallback } from "react";
import { BlobServiceClient } from "@azure/storage-blob";

const AZURE_STORAGE_ACCOUNT_NAME = "nativeshipperfiles";
const AZURE_CONTAINER_NAME = "images";
// const AZURE_SAS_TOKEN =
//   "sv=2022-11-02&ss=b&srt=sco&sp=rwcl&se=2025-12-31T23:59:00Z&st=2024-06-17T00:00:00Z&spr=https&sig=abc123...";
const AZURE_SAS_TOKEN =
  "T94/9eWu8KaOSru2bZSgBWkAI7n1BwqUt506j/0eRokF9zPlNZAb91lc2VhFQYwQGYdkfPsU1dLk+ASt7d9RXQ=="; // <-- your full SAS token here

const ImageUploader = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageList, setImageList] = useState([]);

  // Initialize BlobServiceClient with SAS token
  const blobService = new BlobServiceClient(
    `https://${AZURE_STORAGE_ACCOUNT_NAME}.blob.core.windows.net/?${AZURE_SAS_TOKEN}`
  );
  const containerClient = blobService.getContainerClient(AZURE_CONTAINER_NAME);

  const uploadFile = async () => {
    if (!selectedFile) return;

    const blobClient = containerClient.getBlockBlobClient(selectedFile.name);
    const options = {
      blobHTTPHeaders: {
        blobContentType: selectedFile.type,
      },
    };

    try {
      await blobClient.uploadBrowserData(selectedFile, options);
      alert("✅ Image uploaded!");
      setSelectedFile(null);
      fetchImages(); // Refresh image list
    } catch (err) {
      console.error("❌ Upload failed:", err.message);
      alert("Upload failed. Check console.");
    }
  };

  const fetchImages = useCallback(async () => {
    const blobs = [];
    try {
      for await (const blob of containerClient.listBlobsFlat()) {
        blobs.push(blob.name);
      }
      setImageList(blobs);
    } catch (err) {
      console.error("❌ Fetch failed:", err.message);
    }
  }, [containerClient]);

  useEffect(() => {
    fetchImages();
  }, [fetchImages]);

  return (
    <div style={{ padding: 20, border: "1px solid #ccc", maxWidth: 800 }}>
      <h2>📤 Azure Blob Image Uploader</h2>

      <input
        type="file"
        accept="image/*"
        onChange={(e) => setSelectedFile(e.target.files[0])}
      />
      <button onClick={uploadFile} disabled={!selectedFile}>
        Upload
      </button>

      <hr />

      <h3>📁 Uploaded Images</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
        {imageList.map((fileName) => (
          <div key={fileName}>
            <img
              src={`https://${AZURE_STORAGE_ACCOUNT_NAME}.blob.core.windows.net/${AZURE_CONTAINER_NAME}/${fileName}`}
              alt={fileName}
              width="150"
              style={{ borderRadius: 8 }}
            />
            <p style={{ fontSize: 12 }}>{fileName}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageUploader;
// // src/ImageUploader.js

// import React, { useState, useEffect } from "react";
// import { BlobServiceClient, AnonymousCredential } from "@azure/storage-blob";

// const AZURE_STORAGE_ACCOUNT_NAME = "nativeshipperfiles";
// const AZURE_CONTAINER_NAME = "images";

// const ImageUploader = () => {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [imageList, setImageList] = useState([]);

//   const blobService = new BlobServiceClient(
//     `https://${AZURE_STORAGE_ACCOUNT_NAME}.blob.core.windows.net`,
//     new AnonymousCredential()
//   );
//   const containerClient = blobService.getContainerClient(AZURE_CONTAINER_NAME);

//   const uploadFile = async () => {
//     if (!selectedFile) return;

//     const blobClient = containerClient.getBlockBlobClient(selectedFile.name);
//     const options = {
//       blobHTTPHeaders: {
//         blobContentType: selectedFile.type,
//       },
//     };

//     await blobClient.uploadBrowserData(selectedFile, options);
//     alert("Image uploaded!");
//     setSelectedFile(null);
//     fetchImages(); // refresh list
//   };

//   const fetchImages = async () => {
//     const blobs = [];
//     for await (const blob of containerClient.listBlobsFlat()) {
//       blobs.push(blob.name);
//     }
//     setImageList(blobs);
//   };

//   useEffect(() => {
//     fetchImages();
//   }, []);

//   return (
//     <div style={{ padding: 20, border: "1px solid #ccc" }}>
//       <h2>📤 Azure Blob Image Uploader</h2>
//       <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} />
//       <button onClick={uploadFile} disabled={!selectedFile}>
//         Upload
//       </button>

//       <hr />

//       <h3>📁 Uploaded Images</h3>
//       <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
//         {imageList.map((fileName) => (
//           <div key={fileName}>
//             <img
//               src={`https://${AZURE_STORAGE_ACCOUNT_NAME}.blob.core.windows.net/${AZURE_CONTAINER_NAME}/${fileName}`}
//               alt={fileName}
//               width="150"
//               style={{ borderRadius: 8 }}
//             />
//             <p style={{ fontSize: 12 }}>{fileName}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ImageUploader;
